/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { AppThunk } from "@src/config/store";
import axios from "axios";
import { eulaAPI } from "@src/config/api";
import { EulaAction } from "@src/reducers/slices/eulaSlice";
import { IErrorMessage } from "@advapacs/common";

export const checkAcceptEula = (): AppThunk => async (dispatch) => {
  try {
    dispatch(EulaAction.setAcceptEula(true));
    const response = await axios.get(eulaAPI.CHECK_ACCEPT_EULA);
    if (!response.data?.accepted && response.data?.eula?.content) {
      dispatch(EulaAction.setAcceptEula(false));
      dispatch(EulaAction.setEula(response.data.eula.content));
    }
  } catch (err) {
    dispatch(EulaAction.setErrorMessage(err.response.data as IErrorMessage));
  }
};

export const acceptUserEula = (): AppThunk => async (dispatch) => {
  try {
    await axios.patch(eulaAPI.ACCEPT_EULA);
    dispatch(EulaAction.setAcceptEula(true));
  } catch (err) {
    dispatch(EulaAction.setErrorMessage(err.response.data as IErrorMessage));
  }
};

export const getLatestEula = (): AppThunk => async (dispatch) => {
  try {
    dispatch(EulaAction.setEula(null));
    const response = await axios.get(eulaAPI.GET_LATEST_EULA);
    if (response?.data?.eula?.content) {
      dispatch(EulaAction.setEula(response.data.eula.content));
    }
  } catch (err) {
    dispatch(EulaAction.setErrorMessage(err.response.data as IErrorMessage));
  }
};
